<div class="tile-container-skeleton" *ngIf="loadingData">
  <div fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>

<div class="tile-container" *ngIf="!loadingData">
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="column" class="tile-header">
      Keywords By Creative
    </div>
    <div fxLayout="column">
      <mat-form-field appearance="outline">
        <mat-label>Creative</mat-label>
        <mat-select
          [(ngModel)]="selectedCreative"
          [ngModelOptions]="{ standalone: true }"
          (selectionChange)="changeSelectedCreative($event)"
        >
          <mat-option *ngFor="let c of getCreatives()" [value]="c">
            {{ c }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="table-container" fxLayout="column">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      fxFlex="100%"
      id="kw-table"
      matSortActive="total_sessions"
      matSortDirection="desc"
    >
      <ng-container matColumnDef="keyword">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by keyword">
          Keyword
        </th>
        <td mat-cell *matCellDef="let element">{{ element.keyword }}</td>
      </ng-container>

      <ng-container matColumnDef="mm_count">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by keyword">
          Micromoment Sessions
        </th>
        <td mat-cell *matCellDef="let element">{{ element.mm_count }}</td>
      </ng-container>

      <ng-container matColumnDef="percent_mm">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by keyword">
          Percent Total
        </th>
        <td mat-cell *matCellDef="let element">{{ element.percent_mm + '%' }}</td>
      </ng-container>

      <ng-container matColumnDef="total_sessions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by keyword">
          Total Sessions
        </th>
        <td class="no-border" mat-cell *matCellDef="let element">{{ element.total_sessions }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[10, 20]"
      fxFlex="100%"
      id="kw-paginator"
      showFirstLastButtons
      aria-label="Select page of periodic elements"
    >
    </mat-paginator>
  </div>
</div>
